import { SubCollectionCardListDS } from '@src/components/blocks/sub-collection-card-list-ds'
import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import LegacySubCollectionCardList from './sub-collection-card-list-legacy'
import { SubCollectionCardListProps } from './sub-collection-card-list.types'

export default function SubCollectionCardList(props: SubCollectionCardListProps) {
  if (shouldUseDesignSystem()) {
    return <SubCollectionCardListDS {...props} />
  }

  return <LegacySubCollectionCardList {...props} />
}
